import cadastros from './cadastros'
import frotas from './frotas'

export default [
  ...cadastros,
  ...frotas,
];
